"use strict";

exports.__esModule = true;
exports.default = pageMinHeight;

// this function is used to set the outerwrapper height to keep the page from jumping up on save during development.
function pageMinHeight(_ref) {
  var node = _ref.node,
      updateContext = _ref.updateContext;
  var minHeight = node.offsetHeight;

  if (minHeight > 0) {
    sessionStorage.setItem("wrapperMinHeight", node.offsetHeight);
    updateContext && updateContext({
      wrapperMinHeight: node.offsetHeight
    });
  }
}